import { useSuspenseQuery } from "@tanstack/react-query";
import { type LendingApiClient, useApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function getAutoLoanProductsQueryOptions($api: LendingApiClient) {
  return $api.queryOptions(
    "get",
    "/v2/lending/vehicle_loan_products/",
    {
      params: {
        query: {
          // @ts-expect-error - Adding vehicle_type filter for car loans only
          vehicle_type: "car",
        },
      },
    },
    STANDARD_QUERY_CACHE_CONFIG
  );
}

function useGetAutoLoanProductsQuery() {
  const $api = useApi();
  const query = useSuspenseQuery(getAutoLoanProductsQueryOptions($api));

  return {
    autoLoanProductsData: query.data,
  };
}

export { useGetAutoLoanProductsQuery, getAutoLoanProductsQueryOptions };
